<template>
  <a-modal :title="title" :width="800" :visible="visible" :confirmLoading="confirmLoading" @ok="handleOk" @cancel="handleCancel">
    <a-form :form="form">
      <a-form-item label="供货类别编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入" :disabled="isEdit" v-decorator="['supply_code', { rules: [{ required: true, message: '编码不能为空!' }] }]" />
      </a-form-item>
      <a-form-item label="供货类别名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-input placeholder="请输入" v-decorator="['supply_type', { rules: [{ required: true, message: '名称不能为空!' }] }]" />
      </a-form-item>
      <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-textarea placeholder="请输入" v-decorator="['remark']"></a-textarea>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { supptypeAdd, supptypeUpdate } from '@/api/scmApi'
import pick from 'lodash.pick'
export default {
  name: 'CertificateTypeM',
  components: {},
  data() {
    return {
      form: this.$form.createForm(this),
      title: '新增',
      visible: false,
      confirmLoading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      isEdit: false,
      baseInfo: null
    }
  },
  created() {},
  methods: {
    toAddOrUpdate(record) {
      const _that = this
      _that.visible = true
      this.baseInfo = record ? record : null
      _that.$nextTick(() => {
        _that.form.resetFields()
        if (record) {
          _that.title = '修改'
          _that.isEdit = true
          _that.form.setFieldsValue({
            supply_code: record.supply_code,
            supply_type: record.supply_type,
            remark: record.remark
          })
        } else {
          _that.title = '新增'
          _that.isEdit = false
        }
      })
    },
    handleOk() {
      const _that = this
      _that.form.validateFields((err, values) => {
        if (!err) {
          _that.confirmLoading = true
          const mParam = values
          if (_that.isEdit) {
            mParam['id'] = _that.baseInfo.id
            supptypeUpdate(mParam)
              .then(res => {
                _that.confirmLoading = false
                if (res.code === '0' || res.code === 0) {
                  _that.$message.success('操作成功!')
                  _that.$emit('success')
                  _that.visible = false
                } else {
                  _that.$message.error(res.msg ? res.msg : '请求操作失败,请重试')
                }
              })
              .catch(() => {
                _that.$message.error('请求操作失败,请重试')
              })
          } else {
            supptypeAdd(mParam)
              .then(res => {
                _that.confirmLoading = false
                if (res.code === '0' || res.code === 0) {
                  _that.$message.success('操作成功!')
                  _that.$emit('success')
                  _that.visible = false
                } else {
                  _that.$message.error(res.msg ? res.msg : '请求操作失败,请重试')
                }
              })
              .catch(() => {
                _that.$message.error('请求操作失败,请重试')
              })
          }
        }
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>
